import React from 'react';
import PropTypes from 'prop-types';
import { Body3 } from '../../../atomic/text/Text';
import { CancelOrderButton } from '../../../atomic/buttons/cancelOrderButton/CancelOrderButton';
import { headerList } from './headerList';

export const OrderTableHeader = () => {
  return (
    <thead>
      <tr>
        <th>
          <CancelOrderButton width={16} />
        </th>
        {headerList.map(({ label }) => (
          <th key={label}>
            <Body3 fontWeight={700}>{label}</Body3>
          </th>
        ))}
      </tr>
    </thead>
  );
};

OrderTableHeader.propTypes = {
  headerList: PropTypes.array,
};
